import { label } from '../lib/format';

/**
 * How a counted set divides across a taxonomy, as proportional bars.
 *
 * Bars are scaled against the largest bucket rather than the total, so the
 * shape of a long tail stays visible: against the total, a registry led by one
 * dominant domain renders every other bar as an invisible sliver, which reads
 * as "nothing else here" rather than "less of it".
 *
 * Counts are shown alongside because a bar answers "how does this compare" and
 * only a number answers "how many", and a registry this size is often asked the
 * second question.
 */
export function Distribution({ items }: { items: Array<{ name: string; count: number }> }) {
  const largest = Math.max(...items.map((item) => item.count), 1);
  return (
    <div className="momentum-list">
      {items.map((item) => (
        <div className="distribution-item" key={item.name}>
          <div>
            <strong>{label(item.name)}</strong>
            <div className="progress"><span style={{ width: `${(item.count / largest) * 100}%` }} /></div>
          </div>
          <b>{item.count}</b>
        </div>
      ))}
    </div>
  );
}
